import {
    Billing,
} from '../src/billing';

import {
    init,
    select,
} from 'one-state-core';

import {
    SET,
    RESET,
    SELECT,
    SETPAYMENT,
    SETPAYMENTSUCCESS,
} from './types';

import {
    Actions,
} from './actions';

/**
 * Selectable list suitable for Redux
 * @typeparam T Type of the values
 */
export type SelectList<T> = {
    /**
     * List of values (stored as an array)
     */
    values: T[];

    /**
     * Value selected from the list
     */
    selected?: T;

    /**
     * Bill Payment 
     */
    billpayment?: boolean;
    /**
     * Bill Payment Success
     */
    billpaymentsuccess?: boolean;
};


export const billingdetails = (
    context: any,
    initial?: SelectList<Billing>,
) => {
    const initValue = initial || {
        values: [],
        billpayment: false,
        billpaymentsuccess: false
    };

    return (
        state: SelectList<Billing>,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;

        let updated = state || initValue;
        switch (type) {
            case SET:
                updated = init<Billing>(
                    updated,
                    payload,
                );
                break;
            case SETPAYMENT:
                updated = {
                    ...updated,
                    billpayment: payload,
                }
                break;
            case SETPAYMENTSUCCESS:
                updated = {
                    ...updated,
                    billpaymentsuccess: payload,
                }
                break;

            case RESET:
                updated = initValue;
                break;

            case SELECT:
                updated = select<Billing>(
                    updated,
                    (billing) => (
                        billing.AccountId === payload
                    ),
                );
                break;
        }
        return updated;
    }
};
